import { ContentCopy } from "@mui/icons-material";
import { Box, Button, Tooltip, Typography } from "@mui/material";
import React from "react";

export default function CopyToClipboard({ value, isCenter = true, boxProps, buttonProps, ...props }) {
  return (
    <Box
      display="flex"
      alignContent="center"
      justifyContent={isCenter ? "center" : "flex-start"}
      {...boxProps}
    >
      <Tooltip title="Sao chép">
        <Button
          sx={{ p: 0, ...buttonProps }}
          onClick={() => navigator.clipboard.writeText(value)}
          endIcon={<ContentCopy sx={{ width: "10px" }} />}
        >
          <Typography
            {...props}
            variant="body2"
            sx={{
              maxWidth: "120px",
              textOverflow: "ellipsis",
              overflow: "hidden",
              width: "90%",
              whiteSpace: "nowrap",
              ...props.sx,
            }}
          >
            {value}
          </Typography>
        </Button>
      </Tooltip>
    </Box>
  );
}
